import React, { useContext } from 'react';
import TeacketContext from 'src/context/TeacketContext';
import PropTypes from 'prop-types';
import CollapsibleField from 'src/components/layout/CollapsibleField';
import ConversationHistory from './ConversationHistory';
import ConversationNewMessage from './ConversationNewMessage';

const TicketConversation = ({ ticket }) => {
  const { currentTicket /*, activeViewers */ } = useContext(TeacketContext);
  return (
    <div className='flex flex-col gap-4 pt-4'>
      <CollapsibleField label='Title' value={currentTicket?.title ?? ''} />
      <CollapsibleField label='Content' value={currentTicket?.content ?? ''} />
      <ConversationHistory />
      <ConversationNewMessage />
    </div>
  );
};

TicketConversation.propTypes = {
  ticket: PropTypes.object.isRequired,
};

export default TicketConversation;
